import React, { useState } from "react";
import Grid from "../../../Grid/Grid";
import Accordian from "../../../core/Accordian/Accordian";
import "./faq-accordian.scss";

const FaqAccordian = ({ faqs }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleClick = index => {
    if (selectedIndex !== index) {
      setSelectedIndex(index);
    } else {
      setSelectedIndex(null);
    }
  };

  return (
    <>
      <div className="faq-accordian__top">
        <Grid>
          <div className="faq-accordian__heading-wrapper">
            <h1 className="faq-accordian__heading">FAQ</h1>
          </div>
        </Grid>
      </div>
      <div className="faq-accordian__foreground">
        <Grid>
          <div className="faq-accordian">
            {faqs.map((item, index) => (
              <Accordian
                title={item.title}
                key={index}
                onClick={() => handleClick(index)}
                open={selectedIndex === index ? true : false}
              >
                {item.content}
              </Accordian>
            ))}
          </div>
        </Grid>
      </div>
    </>
  );
};

export default FaqAccordian;
